import React, { useEffect, useRef, useState } from "react";
import ToolbarHeader from "../../components/ToolbarHeader";
import SelectInput from "../../components/FormFields/SelectInput";
import InputWithIcon from "../../components/FormFields/InputWithIcon";
import CustomButton from "../../components/CustomButton";
import { icons } from "../../assets/icons";
import DatePicker from "../../components/FormFields/DatePicker";
import { apiUrls } from "../../utils/api/apiUrls";
import useApi from "../../hooks/useApi";
import { Form, Formik } from "formik";
import moment from "moment";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getBase64, sendToDBDateFormat } from "../../utils/helpers";
import { submitVoucherValidation } from "../../utils/validations/voucher";
import { useAuth } from "../../contexts/AuthContext";

const SubmitVouchers = () => {
  const { data = {}, apiCall } = useApi();
  const { data: vouchers = [], apiCall: getVouchers } = useApi();
  const { apiCall: sendForApproval } = useApi();
  const filePickerRef = useRef([]);
  const navigate = useNavigate();
  const params = useLocation();
  const {
    user: { userLabel = "Store" },
    selectedStores,
  } = useAuth();
  const { storeCode = "" } = selectedStores?.storeDetails || {};

  const onClickAddMore = (values, setFieldValue) => {
    setFieldValue("documents", [
      ...values?.documents,
      {
        date: { value: new Date() },
        head: { value: "" },
        // sub_head: { value: "" },
        amount: { value: "" },
        comment: { value: "" },
        file: { value: "" },
      },
    ]);
  };

  useEffect(() => {
    getVouchers({
      url: apiUrls.dmsService.getRecords,
      method: "post",
      dataToSend: {
        startDate: moment()
          .subtract({ days: 7 })
          .startOf("d")
          .format("YYYY-MM-DD HH:mm:ss"),
        metadataSchemaId: 4,
        endDate: moment().endOf("d").format("YYYY-MM-DD HH:mm:ss"),
        searchText: "",
        status: "SAVED",
      },
    });
  }, []);

  useEffect(() => {
    apiCall({
      url: apiUrls.dmsService.getVoucherHeads,
      method: "get",
      processData: (apiData = []) => {
        const headOptions = apiData?.map((data) => ({
          key: data.headName,
          value: data.headName,
        }));
        // let subHeadOptions = {};
        // const headOptions = [
        //   { key: "Please Select", value: "" },
        //   ...apiData?.map((item) => {
        //     subHeadOptions[item?.headName] = [
        //       { key: "Please Select", value: "" },
        //       ...item?.voucherSubHeads.map((subHead) => ({
        //         key: subHead?.subHeadName,
        //         value: subHead?.subHeadName,
        //       })),
        //     ];
        //     return {
        //       key: item?.headName,
        //       value: item?.headName,
        //     };
        //   }),
        // ];
        return { headOptions };
      },
    });
  }, []);

  const voucherDetails =
    vouchers?.storeGetResponse?.[0]?.dataModalRecordsResponse;

  const amountValuePassAccordingToEditOrSubmit = (
    isEdit,
    values,
    voucherDetails
  ) => {
    let amount = 0;
    if (isEdit) {
      amount = values.total_amount;
    } else {
      console.log("amount 1111", values.total_amount);
      amount =
        values.total_amount +
        Number(
          voucherDetails?.dataModalAttributeSet.find(
            (i) => i.metadataTechnicalName == "amount"
          )?.attributeValue || "0"
        );
    }
    console.log("amount", amount);
    return amount;
  };

  const onSubmitRequest = async (values) => {
    const documents = await Promise.all(
      values?.documents.map(async (item) => {
        let fileData = {};
        if (item?.file?.value?.[0].name) {
          var filename = item?.file?.value[0].name;
          let file = item?.file?.value[0];
          const base64 = await getBase64(file);
          fileData = { document: base64.split(",")[1], documentName: filename };
        }

        let returnObj = {
          dataModalAttributeSet: Object.keys(item)
            .map((key) => {
              if (
                [
                  "file",
                  "id",
                  "documentName",
                  "documentPath",
                  "approval_status",
                  "childId",
                ].includes(key)
              ) {
                return null;
              }
              if (key === "date") {
                let obj = {
                  attributeValue: moment(item?.[key]?.value).format(
                    sendToDBDateFormat
                  ),
                  metadataTechnicalName: key,
                };

                if (item?.[key]?.id) {
                  let idd = voucherDetails?.documents
                    ?.find((it) => it?.id === item?.[key]?.id)
                    ?.dataModalAttributeSet?.find(
                      (it) => it?.metadataTechnicalName === key
                    )?.id;
                  if (idd) {
                    obj.id = idd;
                  }
                }

                return obj;
              } else {
                let obj = {
                  attributeValue: item?.[key]?.value,
                  metadataTechnicalName: key,
                };
                if (item?.[key]?.id) {
                  let idd = voucherDetails?.documents
                    ?.find((it) => it?.id === item?.[key]?.id)
                    ?.dataModalAttributeSet?.find(
                      (it) => it?.metadataTechnicalName === key
                    )?.id;

                  if (idd) {
                    obj.id = idd;
                  }
                }

                return obj;
              }
            })
            .filter((it) => it !== null),
          ...fileData,
          metadataSchemaId: 5,
        };

        if (item.id) {
          returnObj.id = item?.id;
        }
        if (item.documentPath) {
          returnObj.documentPath = item?.documentPath;
        }
        if (item.documentName) {
          returnObj.documentName = item?.documentName;
        }

        let isChildAvail =
          voucherDetails?.documents?.find((ite) => ite.id == item.id) || {};

        if (
          isChildAvail?.childId &&
          params.state.isEditFeatureOn &&
          Object.keys(voucherDetails)?.length > 0
        ) {
          returnObj.childId = isChildAvail?.childId;
        }

        return returnObj;
      })
    );

    let dataToSend = {
      dataModalAttributeSet: [
        {
          attributeValue: values.description,
          metadataTechnicalName: "description",
          id: voucherDetails?.dataModalAttributeSet?.find(
            (it) => it?.metadataTechnicalName === "description"
          )?.id,
        },
        {
          attributeValue: amountValuePassAccordingToEditOrSubmit(
            params.state.isEditFeatureOn,
            values,
            voucherDetails
          ),
          metadataTechnicalName: "amount",
          id: voucherDetails?.dataModalAttributeSet?.find(
            (it) => it?.metadataTechnicalName === "amount"
          )?.id,
        },
      ],
      documents,
      metadataSchemaId: 4,
    };

    if (voucherDetails?.id) {
      dataToSend.id = voucherDetails?.id;
    }

    const { buttonAction = "save" } = values || {};
    if (buttonAction === "save") {
      apiCall({
        url: apiUrls.dmsService.createRecord,
        dataToSend,
        method: "post",
        onSuccess: () => {
          toast.success("Voucher has been saved succesfully");
          navigate(-1);
        },
        onFail: (err) => {
          const { response = {} } = err || {};
          toast.error(response?.statusText || "Something Went Wrong");
        },
      });
    } else {
      // sendForApproval({
      //   url: apiUrls.dmsService.sendForApproval,
      //   dataToSend,
      //   method: "post",
      //   onSuccess: () => {
      //     toast.success("Successfully sent for approval");
      //     navigate(-1);
      //   },
      // });
    }
  };

  const amountToTotal = (val) => {
    return val === "amount" ? "total_amount" : val;
  };

  const initialValues =
    voucherDetails && params.state.isEditFeatureOn
      ? {
          id: voucherDetails?.id,
          [amountToTotal(
            voucherDetails?.dataModalAttributeSet?.[0]?.metadataTechnicalName
          )]: voucherDetails?.dataModalAttributeSet?.[0]?.attributeValue,
          [amountToTotal(
            voucherDetails?.dataModalAttributeSet?.[1]?.metadataTechnicalName
          )]: voucherDetails?.dataModalAttributeSet?.[1]?.attributeValue,
          // [amountToTotal(
          //   voucherDetails?.dataModalAttributeSet?.[0]?.metadataTechnicalName
          // )]: voucherDetails?.documents.find(item => item.dataModalAttributeSet?.[0]?.attributeValue),
          // [amountToTotal(
          //   voucherDetails?.dataModalAttributeSet?.[1]?.metadataTechnicalName
          // )]: voucherDetails?.dataModalAttributeSet?.[1]?.attributeValue,
          documents: (voucherDetails?.documents || []).map((item) => {
            let obj = {};
            item?.dataModalAttributeSet?.forEach((dataSet) => {
              obj[dataSet?.metadataTechnicalName] = {
                value:
                  dataSet?.metadataTechnicalName === "date"
                    ? moment(dataSet?.attributeValue).toDate()
                    : dataSet?.attributeValue,
                id: item?.id,
              };
            });
            obj.id = item?.id;
            if (item?.documentName) {
              obj.documentName = item?.documentName;
            }
            if (item?.documentPath) {
              obj.documentPath = item?.documentPath;
            }
            if (item?.documentPath) {
              obj.file = { value: item?.documentPath };
            }
            return obj;
          }),
        }
      : {
          total_amount: "",
          description: "",
          documents: [
            {
              date: { value: new Date() },
              head: { value: data?.headOptions?.[0]?.key || "", id: undefined },
              // sub_head: { value: "" },
              // description: {value: ""},
              amount: { value: "" },
              comment: { value: "" },
              file: { value: "" },
            },
          ],
        };

  return (
    <div className="dashboard-container">
      <ToolbarHeader
        title="Submit Vouchers"
        showBack
        containerClassName="mt-14"
      />
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(values, actions) => {
          onSubmitRequest(values, actions);
        }}
        // onSubmit={onSubmitRequest}
        validationSchema={submitVoucherValidation}
      >
        {({ errors, touched, values, setFieldValue }) => {
          return (
            <Form>
              <div className="flex flex-col mt-6">
                <div className="font-size-small text-[var(--darkGray2)]">
                  Required Details to Submit Expense Voucher
                </div>
                <div className="bg-[var(--whiteColor)] rounded-[1rem] min-h-[10rem] mt-3 flex flex-col justify-center px-4 py-6 gap-y-5">
                  {values?.documents.map((item, index) => {
                    return (
                      <div
                        className="flex items-cemter gap-x-4"
                        key={"voucher-" + index}
                      >
                        <DatePicker
                          title={index === 0 && "Date"}
                          datePickerClassName="!min-w-[14rem]"
                          onChange={(date) => {
                            let newDocuments = [...values?.documents];
                            newDocuments[index].date = {
                              value: date,
                              id: item.id,
                            };
                            setFieldValue("documents", newDocuments);
                          }}
                          // startDate={item.date?.value}
                          // isSecondMinuteTimeStampActive
                          disabled
                        />
                        <SelectInput
                          title={index === 0 && "Voucher Head"}
                          options={data?.headOptions}
                          onChange={(e) => {
                            let newDocuments = [...values?.documents];
                            newDocuments[index].head = {
                              value: e,
                              id: item.id,
                            };
                            setFieldValue("documents", newDocuments);
                          }}
                          value={item.head?.value}
                          selectClassName={`${
                            index !== 0 && "!mt-0"
                          } !w-[24rem]`}
                          error={
                            touched?.documents?.[index]?.head?.value &&
                            errors.documents?.[index]?.head?.value
                          }
                        />
                        {/* <SelectInput
                          title={index === 0 && "Voucher Sub-Head"}
                          options={
                            data?.subHeadOptions?.[item.head?.value] || [
                              { key: "Please Select", value: "" },
                            ]
                          }
                          onChange={(e) => {
                            let newDocuments = [...values?.documents];
                            newDocuments[index].sub_head = {
                              value: e,
                              id: item.id,
                            };
                            setFieldValue("documents", newDocuments);
                          }}
                          value={item.sub_head?.value}
                          error={
                            touched.documents?.[index]?.sub_head?.value &&
                            errors.documents?.[index]?.sub_head?.value
                          }
                          selectClassName={`${
                            index !== 0 && "!mt-0"
                          } !max-w-[18rem]`}
                        /> */}
                        <InputWithIcon
                          title={index === 0 && "Amount (₹)"}
                          containerClassName={`${
                            index !== 0 && "!mt-0"
                          } !bg-[var(--whiteColor)] border-[1px] border-[var(--borderGray1)] !w-[12.5rem] !h-[5rem]`}
                          placeholder="Amount"
                          onChange={(e) => {
                            let newDocuments = [...values?.documents];
                            newDocuments[index].amount = {
                              value: e,
                              id: item.id,
                            };
                            setFieldValue("documents", newDocuments);
                            setFieldValue(
                              "total_amount",
                              values?.documents?.reduce(function (acc, obj) {
                                return acc + (Number(obj?.amount?.value) || 0);
                              }, 0)
                            );
                          }}
                          value={item.amount?.value}
                          error={
                            touched?.documents?.[index]?.amount?.value &&
                            errors.documents?.[index]?.amount?.value
                          }
                          type={"text"} // Use "text" type to allow decimal values
                        />
                        <InputWithIcon
                          title={index === 0 && "Comment"}
                          containerClassName={`${
                            index !== 0 && "!mt-0"
                          } !bg-[var(--whiteColor)] border-[1px] border-[var(--borderGray1)] !w-[24.5rem] !h-[5rem]`}
                          placeholder="Write Here"
                          onChange={(e) => {
                            let newDocuments = [...values?.documents];
                            newDocuments[index].comment = {
                              value: e,
                              id: item.id,
                            };
                            setFieldValue("documents", newDocuments);
                          }}
                          value={item.comment?.value}
                          error={
                            touched?.documents?.[index]?.comment?.value &&
                            errors.documents?.[index]?.comment?.value
                          }
                        />
                        <div>
                          {index === 0 && (
                            <div
                              className={`font-size-small text-[var(--blackColor)]`}
                            >
                              Attach File
                            </div>
                          )}
                          <CustomButton
                            title={
                              item.file?.value?.[0] || item?.documentPath
                                ? "Uploaded"
                                : "Upload"
                            }
                            wrapperClassName={`${
                              index === 0 && "mt-2"
                            } !h-[5rem]`}
                            onClick={() => {
                              filePickerRef.current[index].click();
                            }}
                          />
                          <div
                            className={`font-size-small text-[var(--textRed)] mt-2`}
                          >
                            {touched.documents?.[index]?.file?.value &&
                              errors.documents?.[index]?.file?.value}
                          </div>
                          <input
                            type="file"
                            // accept="image/*"
                            // accept="image/application/pdf,application/vnd.ms-excel"
                            // accept="application/pdf,image/jpeg,image/png"
                            accept=".pdf, .doc, .docx, .jpg, .jpeg, .png, .xls, .xlsx, .csv"
                            className="hidden"
                            onChange={async (e) => {
                              if (e.target.files[0]?.size > 5 * 1024 * 1024) {
                                alert("File size cannot be more than 5mb");
                              } else {
                                let newDocuments = [...values?.documents];
                                newDocuments[index].file = {
                                  value: e.target.files,
                                  id: item.id,
                                };
                                setFieldValue("documents", newDocuments);
                              }
                            }}
                            ref={(el) => {
                              filePickerRef.current[index] = el;
                            }}
                          />
                        </div>
                        {!params.state.isEditFeatureOn && index !== 0 && (
                          <span
                            className="self-center cursor-pointer"
                            onClick={() => {
                              let currentDocuments = [...values?.documents];
                              currentDocuments.splice(index, 1);
                              setFieldValue("documents", currentDocuments);
                              setFieldValue(
                                "total_amount",
                                currentDocuments?.reduce(function (acc, obj) {
                                  return (
                                    acc + (Number(obj?.amount?.value) || 0)
                                  );
                                }, 0)
                              );
                            }}
                          >
                            <img
                              src={icons.trashIcon}
                              className="w-[2rem] h-[2.4rem]"
                              alt="delete icon"
                            />
                          </span>
                        )}
                      </div>
                    );
                  })}
                </div>
                {!params.state.isEditFeatureOn && (
                  <CustomButton
                    title="Add More Vouchers"
                    wrapperClassName="mt-6 border-[1px] !border-[var(--blackColor)] !bg-transparent self-end !text-[var(--blackColor)] !px-12"
                    onClick={() => onClickAddMore(values, setFieldValue)}
                  />
                )}
                <div className="bg-[var(--whiteColor)] rounded-[1rem] min-h-[10rem] mt-14 px-6 py-6 pb-7">
                  <div className="flex items-center gap-x-12">
                    <InputWithIcon
                      title="Total Voucher Amount in INR(₹)"
                      containerClassName="!w-[30rem] justify-center"
                      labelClassName="font-family-bold font-size-medium"
                      inputClassName="text-center font-family-medium !text-[3rem] !text-[var(--blackColor)] placeholder-[var(--blackColor)]"
                      disabled
                      value={Number(values?.total_amount)?.toFixed(2)}
                    />
                    <InputWithIcon
                      title="Voucher Description:"
                      containerClassName="!bg-[var(--whiteColor)] border-[1px] border-[var(--borderGray1)]"
                      labelClassName="font-family-bold font-size-medium"
                      placeholder="Write Here"
                      wrapperClassName="flex-1"
                      value={values?.description}
                      onChange={(e) => {
                        setFieldValue("description", e);
                      }}
                      // error={
                      //   touched?.description &&
                      //   errors?.description
                      // }
                    />
                  </div>
                  <div className="text-[1.4rem] text-[var(--lightGray2)] mt-3">
                    Calculate automatically on added voucher basis
                  </div>
                </div>
                <div className="flex justify-between items-center mt-6">
                  <CustomButton
                    title="Cancel"
                    wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent self-end !text-[var(--blackColor)] !px-8"
                    onClick={() => {
                      navigate(-1);
                    }}
                  />
                  <div className="flex gap-x-5">
                    <CustomButton // disabled it for temparory
                      title="Save"
                      type="submit"
                      onClick={() => setFieldValue("buttonAction", "save")}
                    />
                    {/* {voucherDetails?.id ? ( */}
                    {/* <CustomButton
                        title="Send For Approval"
                        type="submit"
                        onClick={() =>
                          setFieldValue("buttonAction", "sendForApproval")
                        }
                      /> */}
                    {/* ) : null} */}
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default SubmitVouchers;
